export const loadBrandData = async brand => {
    const brandMap = {
      "uds_default": async () => await import(/* webpackChunkName: "uds_default" */ "./uds_default"),"expedia": async () => await import(/* webpackChunkName: "expedia" */ "./expedia")
    };

    if (brand in brandMap) {
      return await brandMap[brand]();
    } else {
      return await brandMap['expedia']();
    }
  };
  